export const AI_FEATURE_KEYS = {
  PAGE_LEVEL_OVERVIEW: "PAGE_LEVEL_OVERVIEW",
  MODULE_LEVEL_OVERVIEW: "MODULE_LEVEL_OVERVIEW",
  EXEC_REPORT_VIEW: "EXEC_REPORT_VIEW",
  EXEC_REPORT_EXPORT: "EXEC_REPORT_EXPORT",
  DIGEST_EMAIL_ACCESS: "DIGEST_EMAIL_ACCESS",
  AI_ASSISTANT_ACCESS: "AI_ASSISTANT_ACCESS",
};

export default AI_FEATURE_KEYS;
